// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const IntegrationsConstants = Marty.createConstants([
  'MAP_SLACK_USER',
  'CREATE_ACCESS_TOKEN',
  'FETCH_PROTIP',
  'FETCH_INTEGRATION_STATES',
  'FETCH_HUBSPOT_INJECTION_STATE',
  'FETCH_HUBSPOT_TIMELINE_STATE',
  'FETCH_HUBSPOT_COOKIE_STATE',
  'UPDATE_HUBSPOT_INJECTION_STATE',
  'UPDATE_HUBSPOT_TIMELINE_STATE',
  'UPDATE_HUBSPOT_COOKIE_STATE',
  'UPDATE_INTEGRATION_STATE'
])

export default IntegrationsConstants



// WEBPACK FOOTER //
// ./src/scripts/constants/IntegrationsConstants.js